<template>
  <div class="d-flex flex-wrap">
    <div v-for="task in firsts_tasks" :key="task.id" class="mr-2 mb-2">
      <poptip trigger="hover" class="poptip ">
        <div slot="content">
          <p class="mb-1">ID: {{ task.id }}</p>
          <p class="mb-1">{{ $t('autocaller_v2.monitoring.field.number') }}: {{ task.number }}</p>
          <p class="mb-1">
            {{ $t('autocaller_v2.monitoring.field.status') }}:
            {{ $t(`autocaller_v2.monitoring.tasks.${task.state}.state`) }}
          </p>
        </div>
        <badge-status :state="task.state" body_class="task--middle">{{ task.number }}</badge-status>
      </poptip>
    </div>
    <template v-if="is_collapse">
      <div v-for="task in lasts_tasks" :key="task.id" class="mr-2 mb-2">
        <poptip trigger="hover" class="poptip ">
          <div slot="content">
            <p class="mb-1">ID: {{ task.id }}</p>
            <p class="mb-1">{{ $t('autocaller_v2.monitoring.field.number') }}: {{ task.number }}</p>
            <p class="mb-1">{{ $t('autocaller_v2.monitoring.field.status') }}: {{ task.state }}</p>
          </div>
          <badge-status :state="task.state" body_class="task--middle">{{ task.number }}</badge-status>
        </poptip>
      </div>
    </template>
    <icon
      v-if="lasts_tasks.length"
      :type="!is_collapse ? 'ios-arrow-down' : 'ios-arrow-up'"
      class="callers-collapse__controls-icon col-12"
      @click="is_collapse = !is_collapse"
    />
  </div>
</template>

<script>
  import BadgeStatus from './monitoring-badge-status'
  export default {
    components: {
      BadgeStatus
    },
    props: {
      tasks: {
        type: [Array, String],
        default: () => []
      }
    },
    data() {
      return {
        is_collapse: false
      }
    },
    computed: {
      firsts_tasks() {
        return this.tasks.slice(0,24)
      },
      lasts_tasks() {
        return this.tasks.slice(24)
      }
    }
  }
</script>
